import { FormattedMessage } from 'react-intl';
import { Form } from 'components/ui/atoms';
import { AddressStateField } from './address-state-field';
import { useCountryOptions } from './hooks';
import { AddressFormProps } from './types';

export const AddressForm = ({ isDisabled }: AddressFormProps) => {
  const countryOptions = useCountryOptions();

  return (
    <fieldset className="mb-5">
      <legend className="mb-0">
        <h2 className="h5">
          <FormattedMessage
            id="payment.card.holder.information.form.heading"
            defaultMessage="Card Holder Information"
            description="Heading for Address Form"
          />
        </h2>
      </legend>
      <Form.Row>
        <Form.Input
          name="firstName"
          label={
            <FormattedMessage
              id="payment.form.address.first.name"
              defaultMessage="First Name (required)"
              description="Label for Form Input"
            />
          }
          autocomplete="given-name"
          styleClasses="col-lg-6"
          disabled={isDisabled}
        />
        <Form.Input
          name="lastName"
          label={
            <FormattedMessage
              id="payment.form.address.last.name"
              defaultMessage="Last Name (required)"
              description="Label for Form Input"
            />
          }
          autocomplete="family-name"
          styleClasses="col-lg-6"
          disabled={isDisabled}
        />
      </Form.Row>

      <Form.Row>
        <Form.Input
          name="address"
          label={
            <FormattedMessage
              id="payment.form.address.address"
              defaultMessage="Address (required)"
              description="Label for Form Input"
            />
          }
          autocomplete="street-address"
          styleClasses="col-lg-6"
          maxLength={60}
          disabled={isDisabled}
        />
        <Form.Input
          name="unit"
          label={
            <FormattedMessage
              id="payment.form.address.suite"
              defaultMessage="Suite/Apartment Number"
              description="Label for Form Input"
            />
          }
          autocomplete="address-line2"
          styleClasses="col-lg-6"
          maxLength={29}
          disabled={isDisabled}
        />
      </Form.Row>

      <Form.Row>
        <Form.Input
          name="city"
          label={
            <FormattedMessage
              id="payment.form.address.city"
              defaultMessage="City (required)"
              description="Label for Form Input"
            />
          }
          autocomplete="address-level2"
          styleClasses="col-lg-6"
          disabled={isDisabled}
        />
        <Form.Select
          name="country"
          label={
            <FormattedMessage
              id="payment.form.address.country"
              defaultMessage="Country (required)"
              description="Label for Country Select"
            />
          }
          options={countryOptions}
          autocomplete="country"
          styleClasses="col-lg-6"
          disabled={isDisabled}
        />
      </Form.Row>

      <Form.Row>
        <AddressStateField isDisabled={isDisabled} />
        <Form.Input
          name="postalCode"
          label={
            <FormattedMessage
              id="payment.form.address.postal"
              defaultMessage="Zip/Postal Code"
              description="Label for Form Input"
            />
          }
          autocomplete="postal-code"
          styleClasses="col-lg-6"
          maxLength={9}
          disabled={isDisabled}
        />
      </Form.Row>
    </fieldset>
  );
};
